// Import files here. This is the main lib entry point.
// You can use ES5, or ES6 here.
import $ from "jquery";

jQuery.fn.extend({
    live: function(event, callback) {
        if (this.selector) {
            jQuery(document).on(event, this.selector, callback);
        }
    }
});

$(".nav-links").click(function(e) {
    anchorScroll(
        $(this),
        $($(this).attr("href")),
        1200,
        $("#header")
            .get(0)
            .getBoundingClientRect().height
    );
});

function anchorScroll(this_obj, that_obj, base_speed, offset) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 2000;

    $("html,body").animate(
        {
            scrollTop: that_offset.top - offset
        },
        speed
    );
}
